<template>
  <div class="packaging-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="packaging-content">
      <p class="packaging-p indent">Alcomet has a strong presence on the European market.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_1.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-1">Household foil</h4>
      <p class="packaging-p indent">Household foil is used for wrapping food during cooking or to preserve its freshness. Its excellent resistance to the highest temperatures in cooking, its deadfold properties and its role as barrier against light, aroma and steam make it an essential item in every kitchen.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_2.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-2">Container foil</h4>
      <p class="packaging-p indent">Container foil, also called lubricated foil, is used for the production of aluminium containers offering some of the most versatile packaging solutions available today. With its unique set of properties: a 100% barrier against light and gas, heat conductivity, formability, food contact ability and decorative appearance it helps to prevent food waste and provides other great benefits along the food chain to the end consumer.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_3.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-3">Converter foil</h4>
      <p class="packaging-p indent">A unique combination of physical characteristics makes aluminium foil an essential material for the flexible packaging industry  like aseptic cartons, wraps, pouches, bottle neck, push-thru blister, laminated tubes.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_4.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-4">Omnia sheets</h4>
      <p class="packaging-p indent">A special type of sheets developed by Alcomet’s predecessor Alumina, used for the anufacturing of Omnia type jar caps for food preservation in home conditions.</p>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["packaging-1", "Household foil"],
        ["packaging-2", "Container foil"],
        ["packaging-3", "Converter foil"],
        ["packaging-4", "Omnia sheets"]
      ]
    };
  }
};
</script>

<style scoped>
.packaging-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.packaging-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.packaging-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.packaging-link {
  font-size: 19px;
  text-decoration: underline;
}
.packaging-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.packaging-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .packaging-content {
    width: 100%;
  }
  .packaging-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .packaging-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .packaging-link {
    font-size: 16px;
  }
  .packaging-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Packaging.vue